var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7.995 2.424C6.662.866 4.44.446 2.77 1.874 1.1 3.3.864 5.685 2.176 7.373c1.09 1.403 4.39 4.362 5.472 5.32.12.107.181.16.252.182a.336.336 0 0 0 .19 0c.071-.021.131-.075.252-.182 1.082-.958 4.382-3.917 5.472-5.32 1.312-1.688 1.105-4.089-.593-5.5C11.522.46 9.328.865 7.995 2.423Z",
    clipRule: "evenodd"
  })));
};
export default SvgHeart;